import Target from './component';

export default Target;
